/**
 * 선생님 웹·학생 웹이 로그인 성공·로그인 상태 진입마다, 그리고 QR 선택 화면에서 역할을 고를 때
 * 브랜드 상위 도메인에 남기는 마지막 역할.
 * 학습지 QR 진입 시 어느 앱(웹)을 열지 고르는 데 쓴다. 선생님 웹과 이름·값·속성이 같아야 한다.
 */
export const LOGIN_ROLE_COOKIE_NAME = 'mf_role'

export type LoginRole = 'teacher' | 'student'

// Safari ITP 는 JS 로 쓴 쿠키를 7일로 자르므로, 진입할 때마다 다시 써서 연장한다.
const LOGIN_ROLE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

const BRAND_DOMAIN_REGEX = /(?:^|\.)(mathflat\.com|schoolflat\.com|mathflat\.co\.kr)$/

/** 브랜드 도메인이 아니면(localhost·IP·프리뷰) Domain 을 생략해 현재 호스트에만 남긴다. */
export const resolveLoginRoleCookieDomain = (hostname: string): string | undefined => {
  const matched = hostname.match(BRAND_DOMAIN_REGEX)
  return matched ? `.${matched[1]}` : undefined
}

export const parseLoginRole = (cookie: string): LoginRole | null => {
  for (const pair of cookie.split(';')) {
    const [rawName, ...rest] = pair.split('=')
    if (rawName?.trim() !== LOGIN_ROLE_COOKIE_NAME) continue
    const value = rest.join('=').trim()
    if (value === 'teacher' || value === 'student') return value
  }
  return null
}

export const readLoginRole = (): LoginRole | null => parseLoginRole(document.cookie)

export const writeLoginRole = (role: LoginRole) => {
  // 선생님 웹이 iframe 으로 학생 대리 로그인을 띄우면 선생님 브라우저에 student 가 덮어써진다.
  if (window.self !== window.top) return

  const domain = resolveLoginRoleCookieDomain(window.location.hostname)
  const attributes = [
    `${LOGIN_ROLE_COOKIE_NAME}=${role}`,
    'Path=/',
    `Max-Age=${LOGIN_ROLE_MAX_AGE_SECONDS}`,
    'SameSite=Lax',
    ...(domain ? [`Domain=${domain}`] : []),
    ...(window.location.protocol === 'https:' ? ['Secure'] : []),
  ]
  document.cookie = attributes.join('; ')
}
